module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rules-page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Règlement")]), _vm._v(" "), _c('div', {
    staticClass: "rules-page__container"
  }, [_c('div', {
    staticClass: "rules-page__paragraph"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Les règles du jeu")]), _vm._v(" "), _c('p', [_vm._v("Fraichement transféré en Chine, vous vous retrouvez dans la peau d’un joueur professionnel et vous allez devoir, au fil de la saison et au gré de vos rencontres, prendre des décisions qui vont orienter la suite de votre carrière.")]), _vm._v(" "), _c('p', [_vm._v("Finirez-vous idolâtré par tout un pays ou sortirez-vous par la petite porte ?")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "height": "315",
      "src": " https://www.youtube.com/embed/QRczlFaFFt8",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rules-page__paragraph"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("L'idée")]), _vm._v(" "), _c('p', [_vm._v("La Chine est devenu le nouvel eldorado des stars du football. Mais comment se passe l'intégration dans leurs nouveaux clubs et surtout dans leur nouvelle vie chinoise ?")]), _vm._v(" "), _c('p', [_vm._v("Inspirés du célèbre jeu de société « Les Mystères de Pékin » et des « Livres dont vous êtes le héros », nous avons souhaité faire vivre l'expérience chinoise à tous les fans de football.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rules-page__paragraph"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("P2J, c'est quoi ?")]), _vm._v(" "), _c('p', [_vm._v("Né de l’initiative d’une bande de potes, "), _c('a', {
    attrs: {
      "href": "http://www.p2j.fr",
      "target": "_blank"
    }
  }, [_vm._v("Passement de Jambes")]), _vm._v(" est un collectif de podcasteurs fans de football, qui essaient d'inviter à la rencontre et au partage du foot qu’on kiffe : celui qui procure à tous le même frisson quand le ballon franchit la ligne.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rules-page__paragraph"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Remerciements")]), _vm._v(" "), _c('p', [_vm._v("Ce projet n'aurait jamais pu voir le jour sans la contribution des amis de P2J et nous tenions à les remercier.")]), _vm._v(" "), _c('p', [_vm._v("Pour les illustrations et l'univers graphique, leur talent et leur patience : "), _c('a', {
    attrs: {
      "href": "http://distingo.net/",
      "target": "_blank"
    }
  }, [_vm._v("Ludovic")]), _vm._v(" et "), _c('a', {
    attrs: {
      "href": "https://twitter.com/BastienVives",
      "target": "_blank"
    }
  }, [_vm._v("Bastien")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Pour les développements technique et son implication sans faille : "), _c('a', {
    attrs: {
      "href": "http://leobrossault.fr/",
      "target": "_blank"
    }
  }, [_vm._v("Léo")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Pour la conception, la rédaction et leur soutien au quotidien, deux personnes clés dans le montage du projet : "), _c('a', {
    attrs: {
      "href": "https://twitter.com/A_la_buvette",
      "target": "_blank"
    }
  }, [_vm._v("Thomas")]), _vm._v(" et Miguel.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b0a1822"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rules.vue
// module id = 91
// module chunks = 0